// apps/client/src/input/keys.ts — desktop: WASD/arrows, Space/Enter = A, Shift = run, Esc = B, T = tool (spec §8.4)
export type Button = 'A' | 'B' | 'tool';
export function keyVector(keys: ReadonlySet<string>): { x: number; y: number; running: boolean } {
  let x = 0, y = 0;
  if (keys.has('ArrowLeft') || keys.has('KeyA')) x -= 1;
  if (keys.has('ArrowRight') || keys.has('KeyD')) x += 1;
  if (keys.has('ArrowUp') || keys.has('KeyW')) y -= 1;
  if (keys.has('ArrowDown') || keys.has('KeyS')) y += 1;
  const l = Math.hypot(x, y);
  return { x: l > 1 ? x / l : x, y: l > 1 ? y / l : y, running: keys.has('ShiftLeft') || keys.has('ShiftRight') };
}
export function keyButton(code: string): Button | null {
  if (code === 'Space' || code === 'Enter' || code === 'KeyE') return 'A';
  if (code === 'Escape') return 'B';
  if (code === 'KeyT') return 'tool';
  return null;
}
